import {
  ChevronLeftIcon,
  ChevronRightIcon,
  CalendarIcon
} from '../../../../../icons';
import React from 'react';
import './WeeklyPlanSelector.scss';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export const WeeklyPlanSelector = ({
  isError,
  isLoading,
  selectorData,
  dateRange,
  currentWeek,
  onNavigate
}) => {
  const { t } = useTranslation();
  const formatDateRange = (date, isStart) => {
    const momentDate = moment.utc(date);
    return isStart ? momentDate.format('MMM DD') : momentDate.format('DD');
  };
  const { currentWWP, lastWWP, isWWPAvailable, isWWPValid } = selectorData;
  const { start, end } = dateRange;
  const shouldShowDateRange =
    !isError && !isLoading && isWWPAvailable && isWWPValid;
  const canGoBack = currentWWP > 1 && !isLoading;
  const canGoForward = currentWWP < lastWWP && !isLoading;

  const handlePrevious = () => {
    if (canGoBack) {
      onNavigate(-1);
    }
  };

  const handleNext = () => {
    if (canGoForward) {
      onNavigate(1);
    }
  };

  return (
    <div className="weekly-plan-selector">
      <div className="selector-title">{t('weekly_plan.selector_title')}</div>
      <div className="selector-row">
        <button
          className={`nav-button ${canGoBack ? '' : 'disabled'}`}
          onClick={handlePrevious}
          disabled={!canGoBack}>
          <ChevronLeftIcon />
        </button>

        <div className="date-range">
          <CalendarIcon />
          {shouldShowDateRange && (
            <span>
              {t('weekly_plan.week')} {currentWeek} |{' '}
              {formatDateRange(start, true)} - {formatDateRange(end, false)}
            </span>
          )}
        </div>

        <button
          className={`nav-button ${canGoForward ? '' : 'disabled'}`}
          onClick={handleNext}
          disabled={!canGoForward}>
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  );
};

WeeklyPlanSelector.propTypes = {
  isError: PropTypes.bool,
  selectorData: PropTypes.shape({
    currentWWP: PropTypes.number.isRequired,
    lastWWP: PropTypes.number.isRequired,
    isWWPAvailable: PropTypes.bool.isRequired,
    isWWPValid: PropTypes.bool.isRequired
  }).isRequired,
  dateRange: PropTypes.shape({
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired
  }).isRequired,
  onNavigate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  currentWeek: PropTypes.number.isRequired
};
